







































import { Vue, Component, Prop } from "vue-property-decorator";
import CardTitle from "../CardTitle.vue";
import { InstituteInfo } from "../../_models/instituteInfo";
import DetailsInfo from "../Details/DetailsInfo.vue";
import EditDialog from "../Edit/EditDialog.vue";
import * as user from "../../_store/user.module";
import { bus } from "../../main";
import { UserInfo } from "../../_models/userInfo";
import { StudentInfo } from "../../_models/studentInfo";
import ChangePassword from "../ChangePassword.vue";

@Component({
  components: {
    CardTitle,
    EditDialog,
    DetailsInfo,
    ChangePassword
  }
})
export default class InstituteDetails extends Vue {
  // @Prop() instituteInfo!: InstituteInfo
  private titleParams: object;
  private instituteData: InstituteInfo;
  private ruolo: number[];

  constructor() {
    super();
    this.titleParams = {
      title: "Dettagli Istituto",
      cols: "12",
      sm: "6",
      md: "5",
      lg: "4"
    };
    this.instituteData = {
      id: 0,
      ragioneSocialeIstituto: "",
      indirizzoIstituto: "",
      capComuneIstituto: "",
      provinciaIstituto: "",
      nazioneIstituto: "",
      comuneIstituto: "",
      telefono1Istituto: "",
      telefono2Istituto: "",
      emailIstituto: "",
      pecIstituto: "",
      codIstituto: "",
      codMinisterialeIstituto: "",
      dirigenteIstituto: ""
    };
    this.ruolo = [];
  }
  back() {
    window.history.back();
  }

  // test() {
  //   var rawFile = new XMLHttpRequest();
  //   var file = "src/assets/temp.txt";
  //   rawFile.open("GET", file, false);
  //   rawFile.onreadystatechange = function() {
  //     if (rawFile.readyState === 4) {
  //       if (rawFile.status === 200 || rawFile.status == 0) {
  //         var allText = rawFile.responseText;
  //       }
  //     }
  //   };
  //   rawFile.send(null);
  // }

  created() {
    // this.test();
    // this.instituteData = this.instituteInfo
    // console.log(this.instituteData)
    user.dispatchSetInstituteInfo(this["$store"]).then(() => {
      this.instituteData = user.readInstituteInfo(this["$store"]);
    });

    bus.$on("editedInstitute", () => {
      this.instituteData = user.readInstituteInfo(this["$store"]);
    });
  }

  mounted() {
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    if (userInfo === undefined || userInfo === null) {
      var studentInfo: StudentInfo = user.readStudentInfo(this["$store"]);
      this.ruolo = studentInfo.ruoloUtente;
    } else {
      this.ruolo = userInfo.ruoloUtente;
    }
  }
}
